import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import FormularioApp from "app/Core/Components/Formulario/FormularioApp";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import ConfirmacaoApp from "../../Core/Components/Confirmacao/ConfirmacaoApp";
import LogRegistro from "../../Core/Components/LogRegistro/LogRegistroApp";
import * as Actions from "./Store/Actions/EmpresaPessoaFormularioActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        border: "1px solid #d2d2d2",
    },
    cor: {
        color: theme.palette.text.primary,
    }
});

const newEmpresaPessoaFormularioState = {
    idpessoaformulario: null,
    idparent: null,
    tipo: null,
    formulario: {},
    requeridos: null
};

class EmpresaPessoaFormularioDialog extends XAPPComponent {

    state = { ...newEmpresaPessoaFormularioState };

    componentDidUpdate(prevProps) {
        if (this.props.EmpresaPessoaFormulario.error) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaFormulario.error,
                variant: "error"
            });
            this.props.EmpresaPessoaFormulario.error = null;
        }
        if (this.props.EmpresaPessoaFormulario.warning) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaFormulario.warning,
                variant: "warning"
            });
            this.props.EmpresaPessoaFormulario.warning = null;
        }
        if (this.props.EmpresaPessoaFormulario.info) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaFormulario.info,
                variant: "success"
            });
            this.props.EmpresaPessoaFormulario.info = null;
            if (!this.state.idpessoaformulario || this.state.idpessoaformulario === null) {
                this.setState({ idpessoaformulario: this.props.formDialog.props.id });
            }
        }

        if (!prevProps.formDialog.props.open && this.props.formDialog.props.open) {
            var obj = { ...newEmpresaPessoaFormularioState };
            obj.idparent = this.props.idparent;
            obj.idpessoa = this.props.xappRouteParams.empresa;
            obj.tipo = this.props.selected.id;
            obj.formulario = this.getDadosPessoa();

            if (this.props.formDialog.type === "edit" && this.props.formDialog.data) {
                obj = { ...this.props.formDialog.data };
                obj.tipo = this.props.selected.id;
                obj.formulario.idpessoaformulario = obj.idpessoaformulario;
            }

            if (!_.isNull(this.props.selected) && (_.isNull(this.props.template) || !_.isEqual(this.props.template.id, this.props.selected.id))) {
                this.props.clearTemplate();
                this.props.getTemplate(this.props.selected.id);
            }
            this.setState(obj);
        }

        // if (prevProps.formDialog.props.open && !this.props.formDialog.props.open) {
        //     this.props.clearTemplate();
        // }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    closeComposeDialog = () => {
        this.props.formDialog.type === "edit" ? this.props.closeEditDialog() : this.props.closeNewDialog();
    };

    handleChangeFormulario = (_AForm) => {
        this.setState(_.set({ ...this.state }, "formulario", _AForm));
    };

    canBeSubmitted = () => {
        const { requeridos, formulario } = this.state;

        if (Object.keys(formulario).length < 1 || requeridos === null) {
            return false;
        }
        var AResponse = true;
        Object.keys(requeridos).forEach(key => {
            if (AResponse && requeridos[key] &&
                (_.isUndefined(formulario[key]) || _.isNull(formulario[key]) || formulario[key].length < 1)) {
                AResponse = false;
            }
        });

        return AResponse;
    };

    excluir = () => {
        this.props.remove(this.state, this.props.xappRouteParams, this.props.idparent);
        this.closeComposeDialog();
    };

    setRequeridos = (_ARequeridos) => {
        this.setState(_.set({ ...this.state }, "requeridos", _ARequeridos));
    };

    getDadosPessoa = () => {
        const { datapessoa = null } = this.props.EmpresaPessoaFormulario;
        var AResponse = {};
        if (!_.isNull(datapessoa) && !_.isNull(datapessoa?.formulario)) {
            Object.keys(datapessoa.formulario).forEach(key => {
                AResponse["cliente_" + key] = datapessoa.formulario[key];
            });
        }
        return AResponse;
    };

    getDadosImpressao = (_AValue) => {
        var AResponse = _AValue;
        const { sistemas, xappRouteParams } = this.props;
        if (!_.isUndefined(sistemas[xappRouteParams.empresa]) && !_.isNull(sistemas[xappRouteParams.empresa]) && !_.isNull(sistemas[xappRouteParams.empresa].dados)) {
            var ADados = sistemas[xappRouteParams.empresa].dados;
            if (!_.isUndefined(ADados) && !_.isNull(ADados)) {
                Object.keys(ADados).forEach(key => {
                    AResponse["empresa_" + key] = ADados[key];
                });
            }
        }
        return AResponse;
    };

    render() {
        const { formDialog, template = null, save, xappRouteParams, idparent } = this.props;

        return (
            <XAPPDialog
                {...formDialog.props}
                onClose={this.closeComposeDialog}
                fullScreen
                id="EmpresaPessoaFormulario"
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {formDialog.type === "new" ? "Novo formulário" : "Editar formulário"}
                        </Typography>
                        {formDialog.data && (
                            <LogRegistro
                                primaryKey={"idpessoaformulario"}
                                Log={formDialog.data}
                            />
                        )}
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={this.closeComposeDialog}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent classes={{ root: "px-24 py-12" }}>
                    <form autoComplete="on">
                        {!_.isNull(template) &&
                            <FormularioApp
                                Formulario={template}
                                onChange={this.handleChangeFormulario}
                                customProps={[]}
                                setRequeridos={this.setRequeridos}
                                data={this.state.formulario}
                                xappRouteParams={xappRouteParams}
                            />
                        }
                    </form>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    save(this.state, xappRouteParams, idparent);
                                }}
                                disabled={!this.canBeSubmitted()}
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={"save"}
                                label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                            />
                            {formDialog.type === "edit" &&
                                <div className="flex justify-end">
                                    <ConfirmacaoApp
                                        id="PessoaFormulario"
                                        data="PessoaFormulario"
                                        type="button"
                                        disabled={!this.canBeSubmitted()}
                                        onConfirmation={this.excluir}
                                        mensagem={"Tem certeza que deseja excluir esse registro?"}
                                        xappRouteParams={xappRouteParams}
                                        icon={"delete"}
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        label={md.mobile() === null && md.tablet() === null ? "Remover" : ""}
                                        className="bg-red hover:bg-red text-white"
                                    />
                                </div>
                            }
                            {formDialog.type === "edit" && this.state.tipo !== 202 &&
                                <ImprimirApp
                                    data={JSON.stringify(this.getDadosImpressao(this.state.formulario))}
                                    xappRouteParams={xappRouteParams}
                                    key="btnImprimir"
                                    id={"imprimirpessoaformulario"}
                                    idrelatorio={this.state.tipo}
                                    type="Button"
                                    className="bg-blue hover:bg-blue text-white"
                                // column={this.getColumns(ARelatorio.campos)}
                                />
                            }
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearTemplate: Actions.clearTemplate,
        closeEditDialog: Actions.closeEditDialog,
        closeNewDialog: Actions.closeNewDialog,
        save: Actions.save,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
        getTemplate: Actions.getTemplate
    }, dispatch);
}

function mapStateToProps({ auth, PessoaFormulario }) {
    return {
        EmpresaPessoaFormulario: PessoaFormulario,
        formDialog: PessoaFormulario.formDialog,
        template: PessoaFormulario.template,
        user: auth.user.data,
        sistemas: auth.user.data.settings.sistemas,
    };
}




export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(EmpresaPessoaFormularioDialog));
